import { AnalyticsEventProcessorInterface } from '../../shared/modules/analytics/analytics-event-processor.interface';
import { eventDefaults } from './models/event-defaults';

export class AnalyticsEventProcessor implements AnalyticsEventProcessorInterface {
  public process(event: string) {
    const args = event.split(':');
    const func = args.shift();
    // Check if it is a default event
    if (eventDefaults[func]) {
      return this.defaultEvent(args, eventDefaults[func]);
    }

    // Check if we have function for this event.
    if (typeof this[func] === 'function') {
      return this[func](args);
    }

    return {};
  }

  private defaultEvent([eventAction, eventLabel]: Array<string>, defaults) {
    return {
      ...defaults,
      eventAction,
      eventLabel,
    };
  }
}
